import { JsonProperty } from '../../../models/utilities/json-property';
import { ShipmentType } from '../enums/_index';
import { ContainerPaymentType, ContainerSize } from '../enums/_index';
import { ShipmentRead } from '../shipments/shipment-read';

export class ContainerRead extends ShipmentRead {
    
    public carrierId : ContainerPaymentType | undefined = undefined;

    public number : string = '';
    
    public size : ContainerSize | undefined = undefined;
    
    public paymentType : ContainerPaymentType | undefined = undefined;
    
    public seal : string = '';

    public tareWeight : number|undefined = undefined;

    public unloadedWeight : number|undefined = undefined;

    public loadedWeight : number|undefined = undefined;

    constructor() {
        super();
        this.type = ShipmentType.Container;
    }
    
}
